import { useEffect, useState, useCallback } from "react";
import { api } from "../api";

const STORAGE_KEY = "claudeAgentPreferredModel";

/**
 * Catalog of Anthropic models supported by the system-default agent, plus the
 * caller's persisted preference. Selection is purely client-side — the model
 * is sent to the backend on each new-thread creation.
 */
export function useModels() {
  const [models, setModels] = useState([]);
  const [selectedModel, setSelectedModelState] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || null; }
    catch (_) { return null; }
  });

  const setSelectedModel = useCallback((id) => {
    setSelectedModelState(id);
    try {
      if (id) localStorage.setItem(STORAGE_KEY, id);
      else localStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
  }, []);

  useEffect(() => {
    let cancelled = false;
    api.listModels().then((list) => {
      if (cancelled) return;
      setModels(list || []);
      setSelectedModelState((current) => {
        // If the persisted choice isn't in the catalog (e.g., model retired),
        // fall back to the API's default.
        if (current && (list || []).some((m) => m.id === current)) return current;
        const def = (list || []).find((m) => m.is_default);
        return def ? def.id : ((list || [])[0]?.id || null);
      });
    }).catch(() => {
      if (!cancelled) setModels([]);
    });
    return () => { cancelled = true; };
  }, []);

  return { models, selectedModel, setSelectedModel };
}
